import { makeAutoObservable, runInAction } from "mobx";
import { history } from "../..";
import agent from "../api/agent";
import { Notificacion, User, UserFormValues } from "../models/user";
import { store } from "./store";

export default class UserStore {
    user: User | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    get isLoggedIn() {
        return !!this.user;
    }

    // Método para obtener roles de permisos únicos
    roles = () => {
        // Asegúrate de que `this.user.permissions` esté definido y sea un arreglo de permisos
        let result = this.user?.permissions.filter((item, index) => {
            return this.user?.permissions.indexOf(item) === index;
        });
        return result;
    }

    login = async (creds: UserFormValues) => {
        try {
            // Realiza login
            const user = await agent.Account.login(creds);
            store.commonStore.setToken(user.token);

            // Actualiza el estado del usuario y sus permisos
            runInAction(() => {
                this.user = user;
                // Asegúrate de que los permisos se asignen correctamente
                this.user.permissions = user.permissions || [];
            });

            // Aquí obtienes más detalles del usuario
            const fichaPersonal = await agent.SGPersonas.details(user.id);

            // Redirige según sea necesario
            if (!fichaPersonal.isUpdatedInfo) {
                history.push(`/home/profile/editar/${user.id}`);
            } else {
                history.push(`/home/profile/${user?.userName}/${user?.id}/Perfil`);
            }

            store.modalStore.closeModal();
        } catch (error) {
            throw error;
        }
    }

    logout = () => {
        store.commonStore.setToken(null);
        window.localStorage.removeItem('jwt');
        this.user?.permissions.splice(0, this.user.permissions.length);
        this.user = null;
        window.location.href = 'https://inap.gob.gt/app';
    }

    getUser = async () => {
        try {
            const user = await agent.Account.current();
            runInAction(() => this.user = user);
        } catch (error) {
            console.error(error);
        }
    }

    register = async (creds: UserFormValues) => {
        try {
            const user = await agent.Account.register(creds);
            store.commonStore.setToken(user.token);
            runInAction(() => this.user = user);
            localStorage.setItem('pathBack', history.location.pathname.replace('undefined', user?.id));
            history.push(`/home/profile/editar/${user.id}`);
            store.modalStore.closeModal();
        } catch (error) {
            throw error;
        }
    }

    loadNotificar = async () => {
        const getNotificar: Notificacion[] = await agent.Notificar.getNotificar();
        return getNotificar;
    }

    setImage = (image: string) => {
        if (this.user) this.user.image = image;
    }
}